export function ShowBackgroundImages() {
  // Removes class "lazy" from elements when they reach viewport
  let lazyloadImages: NodeListOf<Element>;

  if ('IntersectionObserver' in window) {
    lazyloadImages = document.querySelectorAll('.lazy');

    const imageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          let image = entry.target;
          image.classList.remove('lazy');
          imageObserver.unobserve(image);
        }
      });
    });

    lazyloadImages.forEach(function (image: Element) {
      imageObserver.observe(image);
    });
  } else {
    let lazyloadThrottleTimeout: NodeJS.Timeout;
    lazyloadImages = document.querySelectorAll('.lazy');

    const lazyload = () => {
      if (lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }

      lazyloadThrottleTimeout = setTimeout(() => {
        let scrollTop = window.pageYOffset;

        lazyloadImages.forEach(img => {
          let image = img as HTMLImageElement;

          if (image.offsetTop < (window.innerHeight + scrollTop)) {
            image.src = image.dataset.src ?? '';
            image.classList.remove('lazy');
          }
        });

        if (lazyloadImages.length === 0) {
          document.removeEventListener('scroll', lazyload);
          window.removeEventListener('resize', lazyload);
          window.removeEventListener('orientationChange', lazyload);
        }
      }, 20);
    };

    document.addEventListener('scroll', lazyload);
    window.addEventListener('resize', lazyload);
    window.addEventListener('orientationChange', lazyload);
  }
}